import React from 'react';
import RestartIcon from '../SVG/RestartIcon';
import TrophyIcon from '../SVG/TrophyIcon';
import { CYAN, YELLOW } from '../const';
import _ from 'lodash';
import { SHOW_LEADERS, OVER_RESTART } from '../REDUX/actions';

const GameOverOptions = ({ header, againOnly = false, handleResponse, style = {} }) => {
  let margin = '30px';

  return (
    <div className="message ms-game-over-message fadein-slow" style={style}>
      {header && <span style={{ fontSize: '20px', marginBottom: margin }}>{header}</span>}
      {_.map([0, 1], i => {
        const marginBottom = i ? 0 : margin;
        const color = i ? CYAN : YELLOW;
        return (
          (i || !againOnly) && (
            <div
              key={i}
              className="ms-game-over-option"
              style={{ marginBottom }}
              onClick={() => handleResponse(i ? OVER_RESTART : SHOW_LEADERS)}>
              {i ? <RestartIcon width="36" style={{ gridArea: '1/1' }} /> : <TrophyIcon width="36px" style={{ gridArea: '1/1' }} />}
              <span style={{ gridArea: '1/1', marginLeft: '50px', color }}>{i ? 'Play again' : 'Show high scores'}</span>
            </div>
          )
        );
      })}
    </div>
  );
};

export default GameOverOptions;
